export const UPDATE_SHOW_BESSIE_MODAL = 'UPDATE_SHOW_BESSIE_MODAL';

export const updateShowBessieModal = (bool) => ({
  type: UPDATE_SHOW_BESSIE_MODAL,
  payload: bool
});

export const initialState = {
  showBessieModal: false
};

export const bessieModalReducerKey = 'bessieModal';

export const bessieModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SHOW_BESSIE_MODAL:
      return { ...state, showBessieModal: action.payload };
    default:
      return state;
  }
};

export function getShowBessieModal (state) {
  return state.liveswap[bessieModalReducerKey].showBessieModal;
}
